// extracted by mini-css-extract-plugin
export default {"container":"Dunning_List_container__pT-ZL","detail":"Dunning_List_detail__woboT","twirl":"Dunning_List_twirl__mNMah","details":"Dunning_List_details__ppVJy"};